export default "__VITE_ASSET__BE5Gn2Ai__"